class CustomerInput {
  constructor(customer) {
    if (customer.id !== null) {
      this.id = customer.id;
    }
    //this.brand = customer.brand === null ? "ulu" : customer.brand;
    this.block_streatus =
      customer.block_streatus === null ? false : customer.block_streatus;

    this.send_to_sharpspring = customer.send_to_sharpspring === null ? true : customer.send_to_sharpspring;

    this.webapp_registration_sent_at =
      customer.webapp_registration_sent_at === null ? "" : customer.webapp_registration_sent_at;
    this.webapp_registration_accepted_at =
      customer.webapp_registration_accepted_at === null ? "" : customer.webapp_registration_accepted_at;

    this.company_name =
      customer.company_name === null ? "" : customer.company_name;
    this.company_address =
      customer.company_address === null ? "" : customer.company_address;
    this.company_city =
      customer.company_city === null ? "" : customer.company_city;
    this.company_postal_code =
      customer.company_postal_code === null ? "" : customer.company_postal_code;
    this.company_country =
      customer.company_country === null ? "" : customer.company_country;
    this.company_vat =
      customer.company_vat === null ? "" : customer.company_vat;
    this.company_po = customer.company_po === null ? "" : customer.company_po;

    this.contact_first_name =
      customer.contact_first_name === null ? "" : customer.contact_first_name;
    this.contact_last_name =
      customer.contact_last_name === null ? "" : customer.contact_last_name;
    this.contact_email =
      customer.contact_email === null ? "" : customer.contact_email;
    this.contact_phone =
      customer.contact_phone === null ? "" : customer.contact_phone;
    this.contact_address =
      customer.contact_address === null ? "" : customer.contact_address;
    this.contact_city =
      customer.contact_city === null ? "" : customer.contact_city;
    this.contact_postal_code =
      customer.contact_postal_code === null ? "" : customer.contact_postal_code;
    this.contact_country =
      customer.contact_country === null ? "" : customer.contact_country;

    this.shipping_first_name =
      customer.shipping_first_name === null ? "" : customer.shipping_first_name;
    this.shipping_last_name =
      customer.shipping_last_name === null ? "" : customer.shipping_last_name;
    this.shipping_email =
      customer.shipping_email === null ? "" : customer.shipping_email;
    this.shipping_phone =
      customer.shipping_phone === null ? "" : customer.shipping_phone;
    this.shipping_address =
      customer.shipping_address === null ? "" : customer.shipping_address;
    this.shipping_city =
      customer.shipping_city === null ? "" : customer.shipping_city;
    this.shipping_postal_code =
      customer.shipping_postal_code === null
        ? ""
        : customer.shipping_postal_code;
    this.shipping_country =
      customer.shipping_country === null ? "" : customer.shipping_country;

    this.billing_first_name =
      customer.billing_first_name === null ? "" : customer.billing_first_name;
    this.billing_last_name =
      customer.billing_last_name === null ? "" : customer.billing_last_name;
    this.billing_email =
      customer.billing_email === null ? "" : customer.billing_email;
    this.billing_phone =
      customer.billing_phone === null ? "" : customer.billing_phone;
    this.billing_address =
      customer.billing_address === null ? "" : customer.billing_address;
    this.billing_city =
      customer.billing_city === null ? "" : customer.billing_city;
    this.billing_postal_code =
      customer.billing_postal_code === null ? "" : customer.billing_postal_code;
    this.billing_country =
      customer.billing_country === null ? "" : customer.billing_country;

    this.category = customer.category === null ? "" : customer.category;
    this.source = customer.source === null ? "" : customer.source;

    if (customer.customer_settings === null) {
      this.customer_settings = {};
      this.customer_settings.invoice_imeis = false;
      this.customer_settings.is_whitelabel = false;
      this.customer_settings.is_keurmerk = false;
      this.customer_settings.driver_id = false;
      this.customer_settings.live_driver_id = false;
      this.customer_settings.api = false;
      this.customer_settings.parking = false;
      this.customer_settings.iframe_page = false;
      this.customer_settings.sms = false;
      this.customer_settings.web_app = false;
      this.customer_settings.company_type = "fleet";
    } else {
      this.customer_settings = {};
      this.customer_settings.invoice_imeis =
        customer.customer_settings.invoice_imeis === null
          ? false
          : customer.customer_settings.invoice_imeis;
      this.customer_settings.is_whitelabel =
        customer.customer_settings.is_whitelabel === null
          ? false
          : customer.customer_settings.is_whitelabel;
      this.customer_settings.is_keurmerk =
        customer.customer_settings.is_keurmerk === null
          ? false
          : customer.customer_settings.is_keurmerk;
      this.customer_settings.driver_id =
        customer.customer_settings.driver_id === null
          ? false
          : customer.customer_settings.driver_id;
      this.customer_settings.live_driver_id =
        customer.customer_settings.live_driver_id === null
          ? false
          : customer.customer_settings.live_driver_id;
      this.customer_settings.api =
        customer.customer_settings.api === null
          ? false
          : customer.customer_settings.api;
      this.customer_settings.parking =
        customer.customer_settings.parking === null
          ? false
          : customer.customer_settings.parking;
      this.customer_settings.iframe_page =
        customer.customer_settings.iframe_page === null
          ? false
          : customer.customer_settings.iframe_page;
      this.customer_settings.sms =
        customer.customer_settings.sms === null
          ? false
          : customer.customer_settings.sms;
      this.customer_settings.web_app =
        customer.customer_settings.web_app === null
          ? false
          : customer.customer_settings.web_app;
      this.customer_settings.company_type =
        customer.customer_settings.company_type === null
          ? "fleet"
          : customer.customer_settings.company_type;
    }
  }
}

export default CustomerInput;
